import {
    allVariants,
    collection,
    parentTypeFor,
    routePath,
} from "../_variants/index.js";
import { cancelServiceBulletin, editServiceBulletin, reviseServiceBulletin, signoffServiceBulletin } from "./actions";
import { makeDQNAttachable } from "../DQNs/attachable.js";
import { makeDocumentsAttachable } from "../Documents/attachable.js";
import { makeDrawingAttachable } from "../Drawings/attachable.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"
import { revisions as _revisions } from "../../standardAttachables";
import effectivitiesAttachable from "../Effectivities/attachable.js";

const revisions = {
    ..._revisions
};

revisions.actions = [{
    "label": "Revise Service Bulletin",
    "action": reviseServiceBulletin
}];

const dataFields = [{
    "label": "Number",
    "key": "Number"
}, {
    "label": "Parent",
    "key": "Parent",
    "link": "Database/:ParentType/:ParentID"
}, {
    "label": "Is Resolved?",
    compute( {pageItem} ) {
        return `<span class="font-bold ${pageItem.Signedoff ? 'text-green' : 'text-red'}">${pageItem.Signedoff ? 'Resolved' : 'Unresolved'}</span>`
    }
}, {
    "label": "Comment",
    "key": "Comment",
    "class": "md:col-span-3"
}];

const menuActions = [
    {
        "label": "Edit Service Bulletin",
        "action": editServiceBulletin
    },
    {
        "label": "Resolve Service Bulletin",
        "action": signoffServiceBulletin
    },
    {
        "label": "Revise Service Bulletin",
        "action": reviseServiceBulletin
    },
    {
        "label": "Cancel Service Bulletin",
        "class": "text-red",
        "break": true,
        "action": cancelServiceBulletin
    }
];

/**
 * Build the list + detail vue-router routes for the Service Bulletin
 * register matching the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeServiceBulletinRoutes = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military Service Bulletin" : "Service Bulletin";
    const labelPlural = isMilitary ? "Military Service Bulletins" : "Service Bulletins";
    const sbParentType = parentTypeFor(variant, "ServiceBulletins");
    const sbCollection = collection(variant, "ServiceBulletins");
    const listPath = routePath(variant, "ServiceBulletins");

    return [{
        "path": listPath,
        "component": {...ItemListView},
        "name": labelPlural,
        "meta": {
            "app": variant.app,
            "name": labelPlural,
            "sideNav": true,
            "sideNavSection": "Design Items",
            "appSwitcher": false,
            "icon": variant.appIcon,
            "tableSettings": sbParentType,
            "dataPath": sbCollection,
            "selectionRoute": `Database/${sbParentType}/{ID}`
        }
    }, {
        "path": `${listPath}/:id`,
        "component": ItemView,
        "name": labelSingular,
        "meta": {
            "app": variant.app,
            "name": labelPlural,
            "dataPath": sbCollection,
            "selectionRoute": `Database/${sbParentType}/{ID}`,
            title(item) {
                return `${labelPlural}: ${item.Number}`
            },
            "attachedItems": {
                "Revisions": {
                    "attachables": [revisions]
                },
                "Attached Items": {
                    "attachables": [makeDocumentsAttachable(variant), makeDrawingAttachable(variant), effectivitiesAttachable, makeDQNAttachable(variant)]
                }
            },
            "dataFields": dataFields,
            "menuActions": menuActions,
            "formMetadata": {
                "ParentType": sbParentType
            }
        }
    }];
};

export default allVariants().flatMap(makeServiceBulletinRoutes);
